import React from 'react';

type FieldWithIconProps = {
  icon: string;
  label: string;
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  className?: string;
  readOnly?: boolean;
};

const FieldWithIcon: React.FC<FieldWithIconProps> = ({
  icon,
  label,
  value,
  placeholder,
  onChange,
  className,
  readOnly,
}) => (
  <label
    className={`flex min-w-0 items-center gap-2 rounded border border-[#223046] bg-[#0b1220] px-2 py-1 text-xs text-cockpit-text ${className || ''}`}
  >
    <span className="shrink-0 text-sm">{icon}</span>
    <span className="shrink-0 text-[11px] text-cockpit-text-2">{label}</span>
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      readOnly={readOnly}
      className="min-w-0 flex-1 bg-transparent text-xs text-cockpit-text placeholder:text-cockpit-muted focus:outline-none"
    />
  </label>
);

export default FieldWithIcon;
